import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

const OrdersByUser = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userId = Cookies.get("userId");
                if (!userId) {
                    throw new Error("User not authenticated");
                }

                const data = new FormData();
                data.append("user_id", userId);

                const response = await fetch("https://leapatinternational.com/admin/api/v1/get_orders.php", {
                    method: "POST",
                    body: data
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                setData(result.data);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);
    return (
        <div>
            <div class="container container1">
                <h1 class="title">Orders <span class="highlight"></span></h1>

                <table>
                    <thead>
                        <tr>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Status</th>
                            <th>Price</th>
                            <th>Total Amount</th>
                            <th>Invoice</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((order, index) => (
                                <tr key={order.order_id || index}>
                                    <td>{order.product_name}</td>
                                    <td>{order.quantity}</td>
                                    <td>
                                        <span className={`badge ${order.status === 'pending' ? 'bg-warning rounded-pill' :
                                            order.status === 'approved' ? 'bg-success rounded-pill' :
                                                order.status === 'cancelled' ? 'bg-danger rounded-pill' :
                                                    'bg-secondary rounded-pill'
                                            }`}>
                                            {order.status}
                                        </span>
                                    </td>
                                    <td>₹{parseFloat(order.price).toLocaleString('en-IN')}</td>
                                    <td>₹{parseFloat(order.total_amount).toLocaleString('en-IN')}</td>
                                    <td></td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">
                                    {loading ? 'Loading orders...' : 'No orders found'}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


            <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
                <i className="bi bi-arrow-up"></i>
            </a>


            {/* Optional: Add any other content or components here */}

            <style>
                {`
          /* Add your custom CSS here */
          .service-item-top {
            transition: transform 0.3s ease-in-out;
          }
  
          .service-item-top:hover {
            transform: scale(1.05);
          }
            .container1 {
    background: white;
  padding: 20px;
  margin: auto;
    margin-top: auto;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 135px;
  margin-bottom: 53px;
}

/* Title */
.title {
    font-size: 28px;
    
    margin-bottom: 10px;
}

.highlight {
    color: #17224D;
}

/* Description */
.description {
    font-size: 16px;
   
    margin-bottom: 20px;
}

/* Section Titles */
.section-title {
    font-size: 22px;
    margin-top: 30px;
    border-bottom: 2px solid #17224D;
    padding-bottom: 5px;
}

/* Note Box */
.note {
    
    padding: 10px;
    
    margin-bottom: 20px;
}

/* Warranty Table */
table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

th, td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
}

th {
    background-color: #17224D;
    color: white;
}

/* List of Not Covered Items */
.not-covered {
    list-style: none;
    padding: 0;
}

.not-covered li {
    padding: 8px;
    background: #ffecec;
    margin: 5px 0;
    border-left: 4px solid #ff4d4d;
}

/* Contact Box */
.contact {
    background: #e0f2f1;
    padding: 15px;
    border-left: 4px solid #17224D;
    margin-top: 20px;
    text-align: center;
}
  
          /* Add any additional styling you want */
        `}
            </style>
        </div>
    );
};

export default OrdersByUser;
